/* bluemall — butiksanpassningar i klienten. Egen fil (PLAYBOOK §3).
   ---- 1. Prisformat per marknad -------------------------------------------
   Shopify formaterar presenterade valutor (Markets) med sina egna standarder
   och de går inte att ändra i admin eller API — bara butiksvalutans format är
   inställbart (samma slutsats som homeheart, commit fc9fd61). Uppmätt här:
   CZK renderades "1.627,00 Kč" — tjeckisk norm är "1 627 Kč" (mellanslag som
   tusentalsavgränsare, valutan efter, inga nolldecimaler; källa
   prirucka.ujc.cas.cz/?id=786, verifierad mot 4home.cz). Fel prisformat är
   en av de tio inlärda bedrägerisignalerna i tjeckiska konsumentguider
   ("cizí měna bez upozornění"). CHF över tusen får apostrof enligt
   schweizisk norm. MutationObserver täcker variantbyten och Ajax-kort. */
(function () {
  function formateraPriser(rot) {
    var valuta = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    if (valuta !== 'CZK' && valuta !== 'CHF') return;
    var w = document.createTreeWalker(rot || document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || !/\d/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        var el = n.parentElement;
        if (!el || el.closest('script,style,input,textarea')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var noder = [];
    for (var n = w.nextNode(); n; n = w.nextNode()) noder.push(n);
    noder.forEach(function (n) {
      var v = n.nodeValue;
      if (valuta === 'CZK') {
        /* 1.627,00 Kč -> 1 627 Kč   (punkttusental -> hårt mellanslag; ,00 bort;
           andra decimaler behålls med komma)  */
        v = v.replace(/\b(\d{1,3}(?:\.\d{3})+)(,\d{2})?(\s?Kč)/g, function (_, tal, dec, kc) {
          var d = (dec && dec !== ',00') ? dec : '';
          return tal.replace(/\./g, ' ') + d + kc;
        }).replace(/\b(\d{1,4}),00(\s?Kč)/g, '$1$2');
      } else {
        /* CHF 1,035.00 -> CHF 1'035.00 */
        v = v.replace(/\b(CHF\s?)(\d{1,3}(?:,\d{3})+)(\.\d{2})?/g, function (_, chf, tal, dec) {
          return chf + tal.replace(/,/g, "'") + (dec || '');
        });
      }
      if (v !== n.nodeValue) n.nodeValue = v;
    });
  }
  function starta() {
    formateraPriser(document.body);
    new MutationObserver(function (ml) {
      ml.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach && m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) formateraPriser(n);
          else if (n.nodeType === 3 && n.parentElement) formateraPriser(n.parentElement);
        });
        if (m.type === 'characterData' && m.target.parentElement) formateraPriser(m.target.parentElement);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starta);
  else starta();
})();
